import { createContext, useContext } from 'react';
import { useReadPerson } from '../hooks';
import {
  PersonReadDataContextData as ContextData,
  PersonReadDataContextProps as ContextProps,
} from './types';

const context = createContext<ContextData>({} as ContextData);

const { Provider } = context;

export const usePersonReadDataContext = () => useContext(context);

export const PersonReadDataProvider = ({ children, id }: ContextProps) => {
  const api = useReadPerson(id);
  return (
    <Provider
      value={{
        api,
      }}
    >
      {children}
    </Provider>
  );
};
